import React from "react"

export const defaultProtectState = {
	featureSettings: {},
	globalSettings: {},
}

export const ProtectStateContext = React.createContext(defaultProtectState)

export const ProtectStateProvider = ({ children }) => {
	const [protectState, setProtectState] = React.useReducer(
		(state, newValue) => {
			return {
				...state,
				...newValue,
			}
		},
		defaultProtectState,
	)

	return (
		<ProtectStateContext.Provider value={{ protectState, setProtectState }}>
			{children}
		</ProtectStateContext.Provider>
	)
}
